import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
export function useBlogPosts() {
    return useQuery({
        queryKey: ['blog-posts'],
        queryFn: () => apiClient('/blog'),
        staleTime: 1000 * 60 * 3,
    });
}
export function useCreateBlogPost() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (dto) => apiClient('/blog', { method: 'POST', body: JSON.stringify(dto) }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['blog-posts'] }),
    });
}
export function useUpdateBlogPost(id) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (dto) => apiClient(`/blog/${id}`, { method: 'PATCH', body: JSON.stringify(dto) }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['blog-posts'] }),
    });
}
export function useDeleteBlogPost() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => apiClient(`/blog/${id}`, { method: 'DELETE' }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['blog-posts'] }),
    });
}
//# sourceMappingURL=useBlogPosts.js.map